export interface TokenInfo {
  symbol: string;
  name: string;
  color: string;
}

export const TOKENS: Record<string, TokenInfo> = {
  BNB: { symbol: 'BNB', name: 'BNB', color: '#f0b90b' },
  BTCB: { symbol: 'BTCB', name: 'Bitcoin (BEP-20)', color: '#f7931a' },
  ETH: { symbol: 'ETH', name: 'Ethereum (BEP-20)', color: '#8c8fd6' },
  USDT: { symbol: 'USDT', name: 'Tether USD', color: '#26a17b' },
  BUSD: { symbol: 'BUSD', name: 'Binance USD', color: '#f0b90b' },
  PLG: { symbol: 'PLG', name: 'Pelagos', color: '#22d3a8' },
};

export interface MarketPair {
  id: string;
  base: string;
  quote: string;
  price: number;
  change24h: number;
  high24h: number;
  low24h: number;
  volume24h: number;
  liquidity: number;
}

export const MARKET_PAIRS: MarketPair[] = [
  { id: 'PLG-USDT', base: 'PLG', quote: 'USDT', price: 0.0842, change24h: 6.35, high24h: 0.0891, low24h: 0.0765, volume24h: 1284000, liquidity: 3620000 },
  { id: 'BNB-USDT', base: 'BNB', quote: 'USDT', price: 612.34, change24h: 1.24, high24h: 621.9, low24h: 598.1, volume24h: 48250000, liquidity: 112400000 },
  { id: 'BTCB-USDT', base: 'BTCB', quote: 'USDT', price: 68420.5, change24h: -0.82, high24h: 69120.0, low24h: 67340.2, volume24h: 93140000, liquidity: 204800000 },
  { id: 'ETH-USDT', base: 'ETH', quote: 'USDT', price: 3542.18, change24h: 2.11, high24h: 3588.4, low24h: 3461.9, volume24h: 51230000, liquidity: 98700000 },
  { id: 'PLG-BNB', base: 'PLG', quote: 'BNB', price: 0.0001375, change24h: 4.02, high24h: 0.000142, low24h: 0.000128, volume24h: 342000, liquidity: 890000 },
  { id: 'BUSD-USDT', base: 'BUSD', quote: 'USDT', price: 0.9998, change24h: 0.01, high24h: 1.0002, low24h: 0.9994, volume24h: 12040000, liquidity: 40200000 },
];

export function generateSeries(
  seed: number,
  points = 96,
  volatility = 0.012,
): { t: number; price: number }[] {
  let value = 100;
  let rnd = seed;
  const next = () => {
    rnd = (rnd * 9301 + 49297) % 233280;
    return rnd / 233280;
  };

  const series: { t: number; price: number }[] = [];
  for (let i = 0; i < points; i++) {
    const drift = (next() - 0.48) * volatility;
    value = Math.max(1, value * (1 + drift));
    series.push({ t: i, price: Number(value.toFixed(4)) });
  }
  return series;
}
